<template>
  <div>
    <div class="checkbox form-group sm mb-0"
         @click.stop="checkboxClicked"
         :class="{ checked: amount > 0 }">
      <input type="checkbox"
             style="pointer-events: none"
             :checked="amount > 0"
             :id="`t-${tooth}-${serviceId}`"
             :disabled="readonly"/>
      <label class="mb-0">{{ tooth }}</label>
    </div>
  </div>
</template>

<script setup>
import {useStore} from "vuex"
import {computed, getCurrentInstance, inject, nextTick, onBeforeMount} from "vue"
import {captureScrollAnchor, restoreScrollAnchor} from "@/services/scroll-anchor.service"

const props = defineProps({
  readonly: Boolean,
  serviceId: String,
  tooth: String,
  minAmount: {
    type: Number,
    default: -1
  }
})

const store = useStore()

const versionCount = inject('versionCount')
const recordTeeth = computed(() => store.getters.recordTeethObjects)
const passedServiceQty = computed(() => recordTeeth.value.map(rt => (rt.services.filter(s => s.id === props.serviceId)).length).reduce((a, b) => a + b))
const toothObject = computed(() => recordTeeth.value.find(rt => rt.teeth === props.tooth))
const amount = computed(() => (toothObject.value?.services || []).filter(service => service.id === props.serviceId).length)
const serviceIdsWithLabServicesAttached = computed(() => store.getters.serviceIdsWithLabServicesAttached)
const visit = computed(() => store.state.patient.visit)
const insuranceCompanyIdForAutocomplete = computed(() => {
  return visit.value?.insurance_polis?.insurance_company_id || visit.value?.insurance_company_id || null
})

let i18n = null
let noty = null

onBeforeMount(() => {
  const instance = (getCurrentInstance())
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const checkboxClicked = async (e) => {
  const anchor = captureScrollAnchor(e.currentTarget)
  if(amount.value > 0) {
    if(props.minAmount <= 0) {
      await changeAmount('minus', amount.value)
    }
  } else {
    await changeAmount('plus', 1)
  }
  await nextTick()
  restoreScrollAnchor(anchor)
}

const changeAmount = async (sign, qty = 1) => {
  if(props.readonly) return

  if(sign === 'minus' && serviceIdsWithLabServicesAttached.value.includes(props.serviceId)) {
    if(qty >= passedServiceQty.value) {
      noty.error(i18n.t('cannot_change_services_that_already_have_laboratory_services_attached'))
      return
    }
  }

  if(toothObject.value) {
    await store.dispatch('toggleServiceToToothNewVersion', {
      serviceId: props.serviceId,
      recordTooth: toothObject.value,
      scope: 'tooth',
      sign,
      qty,
      insuranceCompanyId: insuranceCompanyIdForAutocomplete.value
    })
    versionCount.value++
  }
}
</script>
